module.exports = __webpack_public_path__ + "5e7b3b942ffe4cea6e74977b4ce726c3.png";